import Axios from "axios";

declare module "axios" {
  export interface AxiosRequestConfig {
    csrfRetried?: boolean;
  }
}

const axios = Axios.create({
  baseURL: import.meta.env.VITE_AUTH_SERVICE_API_URL,
  withCredentials: true,
  headers: { Accept: "application/json", "Content-Type": "application/json" },
});

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    const config = error?.response?.config;

    // Retry once at most: a request that keeps failing CSRF must
    // surface its error instead of retrying forever
    if (status === 419 && config && !config.csrfRetried) {
      config.csrfRetried = true;

      // Refresh CSRF
      await axios.get("csrf-cookie");

      // Return a new request using the original request's configuration
      return axios(config);
    }

    return Promise.reject(error);
  }
);

export { axios };
